/**
 * @method initUploader(businessKey,token)              // 方法：通过businessKey,token初始化Uploader
 *   @param businessKey {String}                        // 参数：businessKey
 *   @param token {String|Function}                              // 参数：token
 *   @return {Object}                                   // 返回：模块
 *      @param chooseFiles {Function}                       // 返回：选择文件
 *      @param uploadFilesToAxx {Function}                  // 返回：批量上传文件至爱学习集团存储
 *      @param chooseFilesAndUpload {Function}              // 返回：选择文件&&批量上传文件至爱学习集团存储
 *      @param initUploader {Function}                      // 返回：通过businessKey,token初始化Uploader
 *      @param errorType {Object}                           // 返回：上传状态码
 *          @param PARAMETER_ERROR {Number}                     //参数错误
 *          @param UPLOAD_ERROR {Number}                        //上传错误
 *          @param ORTHER_ERROR {Number}                        //其他错误
 *      @param checkFileType {Function}                     // 返回：校验文件格式
 */

/**
 * @method chooseFiles(args)            // 方法：选择文件
 *   @param args {Object}               // 参数：文件参数
 *      multiple {Boolean}                  // 参数：是否多选
 *      accept {Array}                      // 参数：筛选文件格式；例 accept:[".png",".svg"]
 *   @return {Promise<Array<File>>}     // 返回：文件数组；例 Promise.resolve([file1,...,flie_n])
 */

/**
 * @method uploadFilesToAxx(files,onUploadProgress)                 // 方法：批量上传文件至爱学习集团存储
 *   @param files {Array}                                           // 参数：文件数组
 *   @param onUploadProgress {Function(progressEvent,sign)}         // 参数：上传进度回调函数
 *      @param progressEvent                                            // 参数：上传进度
 *      @param sign                                                     // 参数：上传凭证
 *   @return {Promise<Array<response>>}                             // 返回：上传结果数组
 */

/**
 * @method chooseFilesAndUpload(args)                   // 方法：选择文件&&批量上传文件至爱学习集团存储
 *   @param args {Object}                               // 参数：即chooseFiles参数
 *   @return {Promise<Array<response>>}                 // 返回：即uploadFilesToAxx上传结果数组
 */

/**
 * @method checkFileType(files,accept)                 // 方法：校验文件格式
 *   @param files {Array}                              // 参数：文件数组
 *   @param accept {Array}                             // 筛选文件格式；例 accept:[".png",".svg"]
 *   @return {Boolean}                                 // 返回：校验成功与否
 */

import axios from 'axios'
const service = axios.create({
  timeout: 60 * 1000
})
service.interceptors.response.use(response => response.data)

// 打个补丁，需要找低版本浏览器，主要是19年之前的版本，chrome大概80之前的版本
Promise.allSettled = Promise.allSettled || function (arr) {
  var P = this
  return new P(function(resolve, reject) {
    if (Object.prototype.toString.call(arr) !== '[object Array]') {
      return reject(new TypeError(typeof arr + ' ' + arr +
      ' ' + ' is not iterable(cannot read property Symbol(Symbol.iterator))'))
    }
    var args = Array.prototype.slice.call(arr)
    if (args.length === 0) return resolve([])
    var arrCount = args.length

    function resolvePromise(index, value) {
      if (typeof value === 'object') {
        var then = value.then
        if (typeof then === 'function') {
          then.call(value, function(val) {
            args[index] = { status: 'fulfilled', value: val }
            if (--arrCount === 0) {
              resolve(args)
            }
          }, function(e) {
            args[index] = { status: 'rejected', reason: e }
            if (--arrCount === 0) {
              resolve(args)
            }
          })
        }
      }
    }

    for (var i = 0; i < args.length; i++) {
      resolvePromise(i, args[i])
    }
  })
}

const signatureURL = '//storage.aixuexi.com/api/upload/post/signature'

let token = ''
let businessKey = ''

// 参数错误
const PARAMETER_ERROR = 1
// 上传错误
const UPLOAD_ERROR = 2
// 其他错误
const ORTHER_ERROR = 3

const errorType = {
  PARAMETER_ERROR,
  UPLOAD_ERROR,
  ORTHER_ERROR
}

const modules = {
  uploadFilesToAxx,
  chooseFilesAndUpload,
  chooseFiles,
  initUploader,
  errorType,
  checkFileType
}

// 通过businessKey,token初始化Uploader
function initUploader(_businessKey, _token) {
  token = _token
  businessKey = _businessKey
  return modules
}

// 选择文件(multiple:多选; accept:可选文件类型)
function chooseFiles({ multiple = false, accept = [] } = {}) {
  // 选择文件夹todo
  const fileTag = document.createElement('input')
  fileTag.type = 'file'
  fileTag.multiple = multiple
  fileTag.accept = accept.join(',')
  return new Promise((resolve, reject) => {
    fileTag.onchange = () => {
      resolve([...fileTag.files])
    }
    fileTag.onerror = err => {
      console.error(err)
      reject(ORTHER_ERROR)
    }
    fileTag.click()
  })
}

// 校验文件格式
function checkFileType(files, accept) {
  for (const file of files) {
    if (!accept.includes(file.type) && !accept.includes(file.name.slice(file.name.lastIndexOf('.')))) {
      return false
    }
  }
  return true
}

// 获取上传凭证(files:文件数组)
async function getSignature(files) {
  let _token
  let _businessKey
  if (typeof businessKey === 'function') {
    const params = await businessKey()
    _token = params.token
    _businessKey = params.businessKey
  } else {
    if (!token) {
      return Promise.reject(PARAMETER_ERROR)
    }
    if (!businessKey) {
      return Promise.reject(PARAMETER_ERROR)
    }
    _businessKey = businessKey
    _token = typeof token !== 'function' ? token : await token()
  }
  // 设置上传文件
  const uploadFiles = files.map(file => ({
    fileNameOrSuffix: file.name,
    amount: 1
  }))
  // 获取上传凭证
  return service.post(
    signatureURL,
    {
      businessKey: _businessKey,
      needShortURL: false,
      uploadFiles
    },
    {
      headers: { 'X-Storage-Authorization': _token }
    }
  )
}

// 批量选择文件上传
async function chooseFilesAndUpload(options, onUploadProgress) {
  const files = await chooseFiles({ multiple: true, ...options })
  return uploadFilesToAxx(files, onUploadProgress)
}

// 获取上传凭证，处理后的
export async function getUploadSign(files) {
  let res
  let storageTime = new Date().getTime()
  try {
    res = await getSignature(files)
    storageTime = new Date().getTime() - storageTime
    if (!res || res.status === 0) {
      return Promise.reject(new Error(`存储鉴权出错 ${res && res.errorMessage}`))
    }
  } catch (e) {
    let errorMsg = ''
    if (e && e.message) {
      errorMsg = e.message
    }
    return Promise.reject(new Error(`存储接口鉴权出错 ${errorMsg}`, e))
  }
  const signature = res.body || []
  return {
    signature,
    storageTime
  }
}

// 批量上传文件至爱学习集团存储(files:文件数组； onUploadProgress:上传进度回调)
// uploadStatus：为0代表上传成功；其他代表上传错误原因
async function uploadFilesToAxx(files, onUploadProgress = () => {}, signature) {
  if (!Array.isArray(files)) {
    files = [files]
  }
  let storageTime = 0
  // 如果不存在签名，重新后去签名
  if (!signature) {
    const res = await getUploadSign(files)
    storageTime = res.storageTime
    signature = res.signature
  }
  const upStartTime = new Date().getTime()
  const results = await Promise.allSettled(
    files.map(file => {
      const sign = signature.find(sign => file.name === sign.fileNameOrSuffix)
      const uploadInfo = sign.uploadInfo
      const formData = new FormData()
      uploadInfo.bodyArrs.forEach(info => {
        formData.append(info.key, info.value)
      })
      formData.append(uploadInfo.fileKey, file)
      function getResult() {
        return new Promise((resolve, reject) => {
          // 上传文件
          const startTime = new Date().getTime()
          service.post(uploadInfo.url, formData, {
            onUploadProgress: progressEvent => onUploadProgress(progressEvent, sign)
          }).then(res => {
            resolve({
              ...res,
              // 单个图片的上传用时
              uploadTime: new Date().getTime() - startTime
            })
          }).catch(reject)
        })
      }
      return getResult()
    })
  )
  const upRes = results.map((result, index) =>
    (result.status === 'fulfilled' && result.value.errorCode === 0
      ? { ...result.value, uploadStatus: 0, file: files[index] }
      : {
          uploadStatus: (result.reason && result.reason.message) || 'upload error',
          file: files[index]
        })
  )
  return {
    results: upRes,
    uploadAllTime: new Date().getTime() - upStartTime,
    storageTime
  }
}

export { chooseFiles, initUploader, errorType, checkFileType, uploadFilesToAxx }
export default initUploader
